const cacheify = require('./cacheify')

module.exports = {
  getRoute: function (routeId, params) {
    return this.client.get(`/v${this.v}/route/${routeId}/${this._stringify(params)}`)
  },
  getDetailedRoute: function (routeId) {
    return this.getRoute(routeId, { field_set: 'detailed' })
  },
  getDetailedInternalRoute: function (routeId) {
    return this.getRoute(routeId, { field_set: 'detailed_internal'})
  },
  listRoutes: cacheify(function (params) {
    return this.client.get(`/v${this.v}/route/`, {
      params: params,
    })
  }),
  getPaginatedRoutes: function (link) {
    return this.client.get(link)
  },
  deleteRoute: function (routeId) {
    return this.client.delete(`/v${this.v}/route/${routeId}/`)
  },
  getBookmarkedRoutes: function (params) {
    return this.client.get(`/v${this.v}/route_bookmark/`, {
      params: params,
    })
  },
  getBatchOfRoutes: function (routeIds) {
    return this.client.get(`/v${this.v}/route/`, {
      params: {
        self: routeIds,
      },
    })
  },
  deleteRouteBookmark: function (bookmarkId) {
    return this.client.delete(`/v${this.v}/route_bookmark/${bookmarkId}/`)
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/routes.js